import _ from 'lodash';
import arrayMove from 'array-move';
import { TYPES } from './constants';
import { orderArray } from '../../../core/utils/order-array';

export const ADD_CARD_SORT_CATEGORY_ITEM = 'ADD_CARD_SORT_CATEGORY_ITEM';
export const ADD_EMPTY_CATEGORY = 'ADD_EMPTY_CATEGORY';
export const MOVE_CARD_SORT_CATEGORY = 'MOVE_CARD_SORT_CATEGORY';
export const MOVE_CARD_SORT_ITEM = 'MOVE_CARD_SORT_ITEM';
export const MOVE_TEST_SESSION_CARD_SORT_ITEM = 'MOVE_TEST_SESSION_CARD_SORT_ITEM';
export const REMOVE_CARD_SORT_CATEGORY = 'REMOVE_CARD_SORT_CATEGORY';
export const REMOVE_CARD_SORT_CATEGORY_ITEM = 'REMOVE_CARD_SORT_CATEGORY_ITEM';
export const SET_CARD_SORT_CATEGORIES = 'SET_CARD_SORT_CATEGORIES';
export const SET_CARD_SORT_ITEMS = 'SET_CARD_SORT_ITEMS';
export const SET_CARD_SORT_SETTINGS = 'SET_CARD_SORT_SETTINGS';
export const SET_TEST_SESSION_ID = 'SET_TEST_SESSION_ID';
export const UPDATE_CARD_SORT_CATEGORY = 'UPDATE_CARD_SORT_CATEGORY';

export const initialState = {
  cardSortItems: [],
  cardSortCategories: [],
  testSessionId: null,
  sortType: 'hybrid',
  randomCategory: false,
  sortRandom: false,
  tooltipDescription: true,
  uploadImage: true,
  hideName: false,
};

const updateItems = (items, itemId) => {
  let newItems = _.filter(items, (item) => item.id !== itemId);

  newItems = _.map(newItems, (item, index) => ({
    ...item,
    itemOrder: index,
  }));

  return newItems;
};

const updateCategoryItems = (categoryList, id, itemId) => (
  _.map(categoryList, (category) => {
    if (id !== category.id) {
      return { ...category };
    }

    return {
      ...category,
      cardSortItems: updateItems(category.cardSortItems, itemId),
    };
  })
);

const isDuplicatingCategoryItems = (previous, id) => _.isEmpty(_.find(previous.cardSortItems, { id }));

const reducer = (state, action) => {
  switch (action.type) {
    case SET_CARD_SORT_ITEMS: {
      const { sortRandom } = state;

      const cardSortItems = _.isEmpty(state.cardSortItems)
        ? orderArray(action.payload, 'itemOrder', sortRandom) : action.payload;

      return {
        ...state,
        cardSortItems,
      };
    }

    case SET_CARD_SORT_CATEGORIES: {
      const { randomCategory } = state;

      const cardSortCategories = _.isEmpty(state.cardSortCategories)
        ? orderArray(action.payload, 'categoryOrder', randomCategory) : action.payload;

      return {
        ...state,
        cardSortCategories,
      };
    }

    case SET_TEST_SESSION_ID: {
      return {
        ...state,
        testSessionId: action.payload,
      };
    }

    case SET_CARD_SORT_SETTINGS: {
      const { payload } = action;

      return {
        ...state,
        sortType: payload.sortType,
        randomCategory: payload.randomCategory,
        sortRandom: payload.sortRandom,
        tooltipDescription: payload.tooltipDescription,
        uploadImage: payload.uploadImage,
        hideName: payload.hideName,
      };
    }

    case MOVE_CARD_SORT_ITEM: {
      const { id, newIndex } = action.payload;
      let cardSortItems = [...state.cardSortItems];
      const { itemOrder } = _.find(cardSortItems, { id });

      cardSortItems = arrayMove(cardSortItems, itemOrder, newIndex).map((item, idx) => ({
        ...item,
        itemOrder: idx,
      }));

      return {
        ...state,
        cardSortItems,
      };
    }

    case MOVE_CARD_SORT_CATEGORY: {
      const { id, newIndex } = action.payload;
      let cardSortCategories = [...state.cardSortCategories];
      const { categoryOrder } = _.find(cardSortCategories, { id });

      cardSortCategories = arrayMove(cardSortCategories, categoryOrder, newIndex).map((category, idx) => ({
        ...category,
        categoryOrder: idx,
      }));

      return {
        ...state,
        cardSortCategories,
      };
    }

    case MOVE_TEST_SESSION_CARD_SORT_ITEM: {
      const {
        id,
        newIndex,
        categoryId,
      } = action.payload;

      let cardSortCategories = [...state.cardSortCategories];

      cardSortCategories = _.map(cardSortCategories, (cardSortCategory) => {
        const category = cardSortCategory;
        let categoryItems = category.cardSortItems;
        const { itemOrder } = _.filter(categoryItems, { id });

        // Just move items on the same category
        if (category.id !== categoryId || categoryItems.length === 1) {
          return { ...category };
        }

        categoryItems = arrayMove(categoryItems, itemOrder, newIndex).map((item, idx) => ({
          ...item,
          itemOrder: idx,
        }));

        return {
          ...category,
          cardSortItems: categoryItems,
        };
      });

      return {
        ...state,
        cardSortCategories,
      };
    }

    case ADD_EMPTY_CATEGORY: {
      const cardSortCategories = [...state.cardSortCategories];
      const { projectId, id, item } = action.payload;

      const duplicateItemList = [];

      if (item) {
        _.forEach(cardSortCategories, (category) => {
          const cardSortItem = _.find(category.cardSortItems, { id: item.id });
          duplicateItemList.push(!!cardSortItem && cardSortItem.cardSortCategoryId && !item.cardSortCategoryId);
        });
      }

      if (_.includes(duplicateItemList, true)) {
        return { ...state };
      }

      const newCategory = {
        id,
        name: null,
        categoryOrder: cardSortCategories.length,
        cardSortItems: [],
        isDefault: false,
        projectId,
        type: TYPES.CARD_SORT_CATEGORY,
      };

      return {
        ...state,
        cardSortCategories: [...cardSortCategories, newCategory],
      };
    }

    case ADD_CARD_SORT_CATEGORY_ITEM: {
      const { item, categoryId, index } = action.payload;

      // It is where item should be added
      const categoryTarget = _.find(state.cardSortCategories, { id: categoryId });

      if (_.isEmpty(categoryTarget)) {
        return { ...state };
      }

      let cardSortItems = [...state.cardSortItems];
      let cardSortCategories = [...state.cardSortCategories];

      const previousCategoryId = item.cardSortCategoryId;

      if (previousCategoryId
        && previousCategoryId !== categoryTarget.id) {
        // Update previous category items
        const previousCategory = _.find(cardSortCategories, { id: previousCategoryId });

        // If item isn't in the previous category do not add item to the target category
        // and delete target if there are no items
        if (isDuplicatingCategoryItems(previousCategory, item.id)) {
          const hasItems = !_.isEmpty(categoryTarget.cardSortItems);

          return {
            ...state,
            cardSortCategories: hasItems ? cardSortCategories : _.filter(cardSortCategories, ({ id }) => (
              id !== categoryTarget.id
            )),
          };
        }

        previousCategory.cardSortItems = updateItems(previousCategory.cardSortItems, item.id);

        cardSortCategories = _.map(cardSortCategories, (category) => {
          if (category.id !== previousCategory.id) return { ...category };

          return { ...previousCategory };
        });
      } else {
        cardSortItems = updateItems(cardSortItems, item.id);
      }

      // If cardSortItem is not null tester is creating a new category with items.
      let categoryItems = [...categoryTarget.cardSortItems, {
        id: item.id,
        name: item.name,
        description: item.description,
        imageUrl: item.imageUrl,
        cardSortCategoryId: categoryTarget.id,
        itemOrder: categoryTarget.cardSortItems.length,
        type: TYPES.CARD_SORT_ITEM,
      }];

      categoryItems = arrayMove(categoryItems, categoryTarget.cardSortItems.length, index)
        .map((cardSortItem, idx) => ({
          ...cardSortItem,
          itemOrder: idx,
        }));

      const newCategory = {
        ...categoryTarget,
        cardSortItems: categoryItems,
      };

      const categories = _.map(cardSortCategories, (category) => {
        if (category.id !== newCategory.id) return { ...category };

        return { ...newCategory };
      });

      return {
        ...state,
        cardSortCategories: categories,
        cardSortItems,
      };
    }

    case REMOVE_CARD_SORT_CATEGORY: {
      const { id } = action.payload;

      let cardSortCategories = [...state.cardSortCategories];
      let cardSortItems = [...state.cardSortItems];

      cardSortCategories = _.filter(cardSortCategories, (cardSortCategory) => {
        const { cardSortItems: categoryItems } = cardSortCategory;

        const isDeleted = cardSortCategory.id === id;

        // check if category is being deleted has items
        if (isDeleted && !_.isEmpty(categoryItems)) {
          // move items from category back to the left side
          const itemsFromCategory = _.map(categoryItems, (categoryItem, index) => ({
            ...categoryItem,
            itemOrder: cardSortItems.length + index,
          }));

          cardSortItems = _.concat(cardSortItems, itemsFromCategory);
        }

        return !isDeleted;
      });

      cardSortCategories = _.map(cardSortCategories, (category, index) => ({
        ...category,
        categoryOrder: index,
      }));

      return {
        ...state,
        cardSortCategories,
        cardSortItems,
      };
    }

    case REMOVE_CARD_SORT_CATEGORY_ITEM: {
      const cardSortItems = [...state.cardSortItems];
      let cardSortCategories = [...state.cardSortCategories];

      const {
        item: {
          id: itemId,
          cardSortCategoryId: previousCategoryId,
        },
        categoryTargetId,
      } = action.payload;

      if (categoryTargetId === previousCategoryId) {
        // should not remove item if category target is the same as previous.
        // but should remove item if it is already in left side.

        const isInLeftSide = !_.isEmpty(_.find(cardSortItems, { id: itemId }));

        if (isInLeftSide) {
          cardSortCategories = updateCategoryItems(cardSortCategories, categoryTargetId, itemId);
        }
      } else {
        // should remove item if previous category not is category target
        cardSortCategories = updateCategoryItems(cardSortCategories, previousCategoryId, itemId);
      }

      return {
        ...state,
        cardSortCategories,
      };
    }

    case UPDATE_CARD_SORT_CATEGORY: {
      const { category } = action.payload;

      let cardSortCategories = [...state.cardSortCategories];

      cardSortCategories = _.map(cardSortCategories, (cardSortCategory) => {
        if (cardSortCategory.id !== category.id) return cardSortCategory;

        return { ...category };
      });

      return {
        ...state,
        cardSortCategories,
      };
    }

    default:
      return state;
  }
};

export default reducer;
